import * as z from "zod";
import { mutator } from "./mutator";

export const deleteServiceAccountSchema = z.object({
  id: z.string(),
});

// Deleting an account cascades to its credentials, grants (as principal and as
// scope), and federation configs via ON DELETE CASCADE. Requires
// service_account:manage on the account.
export const deleteServiceAccount = mutator({
  schema: deleteServiceAccountSchema,
  resolve: {
    serviceAccount: { kind: "serviceAccount", from: "id" },
  },
  permissions: [
    {
      permission: "service_account:manage",
      scopeId: ({ args }) => args.serviceAccount.id,
    },
  ],
  fn: async ({ tx, args: { serviceAccount } }) => {
    await tx.mutate.serviceAccounts.delete({ id: serviceAccount.id });
  },
});
